import React, { useEffect, useState } from "react";
import UploadIcon from "../../assets/img/upload-icon.svg";

const EMPSingleFileUpload = ({
  index,
  handleOnChange,
  options,
  setMinorCandidate,
  saveDate,
  handleFileUpload,
  inputType,
  inputLabel,
  inputName,
  inputValue,
  isInputMandatory,
  parentalTemplateUrl,
  isFileUploadedObject,
  isField,
  uploadedFilePreview = "n.a",
  record,
}) => {
  const uploadFile = async (event) => {
    event.persist();
    if (!event.target || !event.target.files) {
      return;
    }
    const file = event.target.files[0];
    handleFileUpload("check_documents", file, record);
  };

  return (
    <div className="floating-label">
      <div className="upload-box">
        <div className="left d-flex align-items-center">
          <img
            src={
              uploadedFilePreview === "n.a" ? UploadIcon : uploadedFilePreview
            }
            className="mr-2"
            alt=""
            style={{ cursor: "pointer", height: "50px" }}
          />
          <span>
            <h6 className="m-0">{inputLabel}</h6>
          </span>
        </div>

        <label htmlFor="file-upload">
          <div className="right text-right">
            <input
              id="file-upload"
              type="file"
              style={{ opacity: "0" }}
              accept="image/*"
              onChange={(e) => uploadFile(e)}
            ></input>
          </div>
        </label>
      </div>
    </div>
  );
};

export default EMPSingleFileUpload;
